import { Link } from "react-router-dom";

const PublicFooter = () => (
  <footer className="border-t py-8 bg-background">
    <div className="max-w-5xl mx-auto px-4 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-muted-foreground">
      <p>Busca Clínicas &copy; {new Date().getFullYear()} — Clínicas de Reabilitação e Recuperação</p>
      <nav className="flex flex-wrap gap-4">
        <Link to="/mapa" className="hover:text-foreground transition-colors">Mapa de Clínicas</Link>
        <Link to="/login" className="hover:text-foreground transition-colors">Área do Profissional</Link>
        <Link to="/registro" className="hover:text-foreground transition-colors">Cadastre-se</Link>
        <Link to="/termos-de-uso" className="hover:text-foreground transition-colors">Termos de Uso</Link>
        <Link to="/politica-de-privacidade" className="hover:text-foreground transition-colors">Política de Privacidade</Link>
        <Link to="/contato-dpo" className="hover:text-foreground transition-colors">Contato DPO</Link>
      </nav>
    </div>
  </footer>
);

export default PublicFooter;
